import { IFile } from 'src/app/interfaces/io/file.interface';
import { ILaunchSettings } from 'src/app/interfaces/io/launch-settings.interface';
import { DynamicAppLoaderService } from '../../dynamic-app-loader.service';
import { VfmService } from '../../io/vfm.service';
import { WindowsManagerService } from '../../os/windows-manager.service';
import { ILauncher } from './launcher.interface';
import { LocalAppLauncher } from './local-app-launcher';

export class LnkLauncher implements ILauncher {
  constructor(
    private windowsMgr: WindowsManagerService,
    private dynamicAppLoader: DynamicAppLoaderService,
    private vfs: VfmService) {
  }

  async launch(file: IFile, path: string, settings?: ILaunchSettings): Promise<number> {
    const local = new LocalAppLauncher(this.windowsMgr, this.dynamicAppLoader);
    let content = (path && path.startsWith("app://")) ? path : await this.vfs.readTextFile(path);

    if (content.startsWith("app://") && content.includes(",")) {
      const spl = content.split(",");
      content = spl.shift().trim();
      settings = settings || {};
      settings.args = spl.map(m => m.trim());
    }

    return await local.launch(file, content, settings);
  }
}
